import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { List } from '@mui/material'
import { colors } from '@global/constants'

export const flex = css`
  display: flex;
  justify-content: space-between;
`

export const list = css`
  padding: 0;
`

export const StyledList = styled(List)<{ height: string }>`
  max-height: ${props => props.height};
  overflow: auto;
`

export const titleLabel = css`
  margin-left: 0;
`

export const listItemButton = css`
  padding-top: 2px;
  padding-bottom: 2px;
  justify-content: space-between;
  background-color: ${colors.ghostWhite};

  .MuiFormControlLabel-label {
    line-height: 1.2em;
  }

  &:hover {
    background-color: ${colors.ghostWhite};
  }
`

export * from '../../styles'
